const pick = (object: {[k: string]: any}, fields: string[]) => {
    return fields.reduce((obj, field) => {
        obj[field] = object[field];
        return obj;
    }, {} as {[k: string]: any});
};

export default pick;
